import { articleApi } from '../../article/services/articleApi'

export const dashboardApi = {
  listArticles: (params?: { state?: string }) => articleApi.list({ ...params, mine: true }),
  submitArticle: (id: string | number) => articleApi.submit(id),
  deleteArticle: (id: string | number) => articleApi.remove(id),
}
